import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Global from '../../APIConfig';
import { toast } from '../../components/ui/toast';
import AuthUser from '../../AuthUser';
import SpinnerLoader from '../Loaders/Spinner';
import PasswordInput from '../../components/ui/PasswordInput';

/**
 * LoginForm — sign-in form used inside the AuthScreen tab switch.
 * Logic unchanged from the original login page (CustomerLogin flow).
 */
export default function LoginForm() {
  let navigate = useNavigate();
  const { setToken } = AuthUser();
  const [Email, setEmail] = useState('');
  const [Password, setPassword] = useState('');
  const [loading, setloading] = useState(false);

  const handleSubmit = () => {
    if (Email == "" || Email == undefined) {
      toast.error("Please Enter A Valid Email Address");
    }
    else if (Password == "" || Password == undefined) {
      toast.error("Please Enter A Valid Password");
    }
    else {
      setloading(true);
      axios({
        method: 'post',
        url: Global.baseUrl + 'CustomerLogin',
        data: {
          email: Email,
          password: Password
        }
      })
        .then(function (response) {
          if (response.data.status == 200) {
            if (response.data.user != undefined) {
              let res = setToken(response.data.user, response.data.user.token);
              if (res == 1) {
                setloading(false);
                toast.success(response.data.message);
                localStorage.setItem('selectedoption', JSON.stringify('Master Dashbaord'));
                navigate('/Customer-Dash');
                window.location.reload();
              } else {
                setloading(false);
                toast.error("Something Went Wrong!!");
              }
            } else {
              setloading(false);
              toast.error(response.data.message);
            }
          }
          else {
            setloading(false);
            toast.error(response.data.message);
          }
        })
        .catch(function (error) {
          setloading(false);
          console.log(error);
        });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <>
      {loading == true && <SpinnerLoader />}
      <form autoComplete="off">
        <div className="pxl-field">
          <label htmlFor="pxl-email">Email</label>
          <input id="pxl-email" type="text" placeholder="you@company.com" name="email"
            autoComplete="new-email" value={Email} onChange={(e) => setEmail(e.target.value)} onKeyDown={handleKeyDown} />
        </div>
        <div className="pxl-field">
          <label htmlFor="pxl-pass">Password</label>
          <PasswordInput id="pxl-pass" placeholder="Your password" name="password"
            autoComplete="new-password" value={Password} onChange={(e) => setPassword(e.target.value)} onKeyDown={handleKeyDown} />
        </div>
        <button type="button" className="pxl-btn" onClick={handleSubmit}>Sign in</button>
      </form>
    </>
  );
}
